import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="2">
    <Text bold size="small">
      2. INTRODUÇÃO
    </Text>
    <Separator weight={4} />
    <Text>
      Em 12 de março de 2020, a Portaria no 6.730 da Secretária Especial de Previdência e Trabalho aprovou a redação da
      Norma Regulamentadora, NR-1, que estabelece as disposições gerais, o campo de aplicação, os termos e as definições
      comuns às Normas Regulamentadoras - NR relativas à segurança e saúde no trabalho e as diretrizes e os requisitos
      para o gerenciamento de riscos ocupacionais e as medidas de prevenção em Segurança e Saúde no Trabalho – SST.
      <br />
      O Gerenciamento de riscos ocupacionais traz como responsabilidade constituir o Programa de Gerenciamento de Riscos
      – PGR que por critério da organização pode ser implementado por unidade operacional, setor ou atividade.
      <br />
      O PGR pode ser atendido por sistemas de gestão, desde que estes cumpram as exigências previstas nesta NR e em
      dispositivos legais de segurança e saúde no trabalho.
      <br />
      O PGR deve contemplar ou estar integrado com planos, programas e outros documentos previstos na legislação de
      segurança e saúde no trabalho.
      <br />
      O PGR constitui-se numa ferramenta de extrema importância para a segurança e saúde dos empregados, devendo estar
      articulado com as demais NR, proporcionando identificar as medidas de proteção ao trabalhador a serem
      implementadas e também serve de base para a elaboração do Programa de Controle Médico e Saúde Ocupacional – PCMSO,
      obrigatório pela NR-7.
      <br />
      Este PGR contém o Inventário Geral dos Riscos relacionados às atividades existentes na empresa, compreendendo
      todas as categorias de riscos à segurança e saúde dos trabalhadores e constitui um dos documentos básicos do
      Programa de Gestão de Riscos, no que diz respeito ao reconhecimento e avaliação de riscos relacionados a agentes
      físicos, químicos, biológicos, ergonômicos e mecânicos.
      <br />
      Atende às exigências da Norma Regulamentadora 09, no que diz respeito ao reconhecimento e avaliação de riscos
      relacionados a agentes químicos, físicos e biológicos.
      <br />
      Atende as exigências da Norma Regulamentadora 17 – Ergonomia, indicando situações nas quais se faz necessário a
      realização de Análise Ergonômica do Trabalho complementares.
      <br />
      Os dados constantes neste documento servem de base para a elaboração do Plano de Ação de Segurança e Saúde do
      Trabalho, que contempla as ações de controle a serem mantidas, implementadas ou melhoradas, assim como as
      atividades de monitoramento das exposições.
      <br />
      A organização deve adotar mecanismo para consultar os trabalhadores quanto à percepção de riscos ocupacionais,
      podendo para este fim ser adotadas as manifestações da Comissão Interna de Prevenção de Acidentes - CIPA, quando
      houver; e comunicar aos trabalhadores sobre os riscos consolidados no inventário de riscos e as medidas de
      prevenção do plano de ação do PGR.
      <br />O empregador deverá garantir que, na ocorrência de riscos nos locais de trabalho que coloquem{' '}
      <b>
        <u>
          em situação de grave e iminente risco um ou mais trabalhadores, os mesmos possam interromper de imediato as
          suas atividades,
        </u>{' '}
      </b>
      comunicando o fato ao superior hierárquico direto para as devidas providências.
      <br />
      Comprovada pelo empregador a situação de grave e iminente risco, não poderá ser exigida a volta dos trabalhadores
      à atividade enquanto não sejam tomadas as medidas corretivas.
    </Text>
    <Separator weight={8} />
    <Text bold size="small">
      2.1 OBJETIVOS
    </Text>
    <Text>
      O PGR tem como objetivo a preservação da saúde e a integridade física dos trabalhadores, através da identificação
      dos perigos e possíveis lesões ou agravo à saúde, a avaliação dos riscos ocupacionais indicando o nível, e a
      classificação dos riscos para determinar a necessidade de adoção de medidas de prevenção de acordo com a ordem de
      prioridade estabelecida na NR1 subitem 1.4.1 alínea “g”.
      <br />
    </Text>
    <Text>Os objetivos deste Inventário Geral de Riscos são:</Text>
    <br />
    <Text>
      <ul>
        <li>
          Caracterizar exposições a todas as condições perigosas e aos agentes potencialmente nocivos – químicos,
          físicos, biológicos e outros fatores estressores que constituem cargas de trabalho significativas.
        </li>
        <li>
          Caracterizar a intensidade e a variação temporal das exposições para todos os trabalhadores – próprios e de
          contratadas que atuem em atividades dentro dos limites da empresa.
        </li>
        <li>Avaliar os riscos potenciais à segurança e saúde de todos os trabalhadores. </li>
        <li>
          Priorizar e recomendar ações para controlar exposições que representem riscos inaceitáveis e intoleráveis.
        </li>
        <li>Registrar as avaliações ambientais realizadas na empresa.</li>
        <li>
          Comunicar os resultados do processo de levantamento de perigos e avaliação de riscos para todos os
          trabalhadores envolvidos.
        </li>
        <li>
          Manter o registro histórico das exposições para todos os trabalhadores de forma que problemas futuros de saúde
          possam ser analisados e gerenciados com base em informações reais de exposição.
        </li>
      </ul>
    </Text>
    <Separator weight={8} />
    <Text bold size="small">
      2.2 DOCUMENTAÇÃO
    </Text>
    <Text>
      O PGR deve conter no mínimo os seguintes documentos: o inventário de riscos e plano de ação, a ser elaborado pela
      organização, respeitados as demais Normas Regulamentadoras, datados e assinados.
      <br />
      Os documentos integrantes do PGR devem estar sempre disponíveis aos trabalhadores interessados ou seus
      representantes e à Inspeção do Trabalho.
    </Text>
    <Separator weight={8} />
    <Text bold size="small">
      2.3 INVENTÁRIO DE RISCO OCUPACIONAIS
    </Text>
    <Text>
      Os dados da identificação dos perigos e das avaliações dos riscos ocupacionais devem ser consolidados em um
      inventário de riscos ocupacionais, que deve contemplar, no mínimo, as seguintes informações:
      <ul>
        <li>Caracterização dos processos e ambientes de trabalho;</li>
        <li>Caracterização das atividades;</li>
        <li>
          {' '}
          Descrição de perigos e de possíveis lesões ou agravos à saúde dos trabalhadores, com a identificação das
          fontes ou circunstâncias, descrição de riscos gerados pelos perigos, com a indicação dos grupos de
          trabalhadores sujeitos a esses riscos, e descrição de medidas de prevenção implementadas;
        </li>
        <li>
          {' '}
          Dados da análise preliminar ou do monitoramento das exposições a agentes físicos, químicos e biológicos e os
          resultados da avaliação de ergonomia nos termos da NR-17.
        </li>
        <li> Avaliação dos riscos, incluindo a classificação para fins de elaboração do plano de ação; e</li>
        <li> Critérios adotados para avaliação dos riscos e tomada de decisão.</li>
      </ul>
    </Text>
    <Separator weight={8} />
    <Text bold size="small">
      2.4 PLANO DE AÇÃO
    </Text>
    <Text>
      A organização deve elaborar plano de ação, indicando as medidas de prevenção a serem introduzidas, aprimoradas ou
      mantidas, conforme classificação, observado o nível de risco ocupacional, determinado pela combinação da
      severidade das possíveis lesões ou agravos à saúde com a probabilidade ou chance de sua ocorrência, para fins de
      identificar a necessidade de adoção de medidas de prevenção e elaboração do plano de ação.
      <br />
      Para as medidas de prevenção deve ser definido cronograma, formas de acompanhamento e aferição de resultados.
    </Text>
    <Separator weight={8} />
    <Text bold size="small">
      2.5 DEFINIÇÃO DAS RESPONSABILIDADES
    </Text>
    <Separator weight={5} />
    <Text bold size="small">
      2.5.1 DO EMPREGADOR/ RESPONSÁVEL LEGAL:
    </Text>
    <Text>
      O empregador é o responsável por estabelecer, implementar e assegurar o cumprimento do PGR bem como as demais
      documentações que o compõe, como atividade permanente da empresa, bem como consultar os trabalhadores quanto à
      percepção de riscos ocupacionais, podendo para este fim ser adotadas as manifestações da Comissão Interna de
      Prevenção de Acidentes - CIPA, quando houver; comunicar aos trabalhadores sobre os riscos consolidados no
      inventário de riscos e as medidas de prevenção do plano de ação; adotar medidas necessárias para melhorar o
      desempenho em SST; O processo de identificação de perigos e avaliação de riscos ocupacionais considerando o
      disposto nas Normas Regulamentadoras e demais exigências legais de segurança e saúde no trabalho e controle dos
      riscos.
    </Text>
    <Separator weight={5} />
    <Text bold size="small">
      2.5.2 DOS TRABALHADORES:
    </Text>
    <Text>
      Os trabalhadores têm como responsabilidade colaborar e participar na implantação e execução do PGR.
      <br />
      Seguir as orientações recebidas nos treinamentos oferecidos dentro do PGR; e informar ao seu superior hierárquico
      direto as ocorrências que, a seu julgamento, possam implicar em riscos à saúde dos trabalhadores.
    </Text>
    <Separator weight={5} />
    <Text bold size="small">
      2.5.3 INTEGRAÇÃO COM A CIPA
    </Text>
    <Text>
      O PGR, suas alterações e complementações deverão ser apresentados e discutidos na Comissão Interna de Prevenção de
      Acidentes - CIPA, quando existente na empresa, de acordo com a NR-5, sendo uma cópia anexada ao livro de ata dessa
      comissão.
    </Text>
    <Separator weight={4} />
    <Text bold size="small">
      2.6 ABRANGÊNCIA
    </Text>
    <Text>
      Este Programa abrangerá os riscos identificados no ambiente de trabalho da empresa, conforme estabelecido na NR 1
      da Portaria 3214/78.
      <br />O processo se inicia com a caracterização básica de cada unidade – processo e ambiente de trabalho, força de
      trabalho e agentes ambientais e estressores. Esses dados servem de base para definir os grupos homogêneos de
      exposição (GHE) e atividades não rotineiras ou de empresas contratadas, para os quais os riscos serão reconhecidos
      e avaliados.
    </Text>
    <Separator weight={4} />
    <Text bold size="small">
      FONTE GERADORA
    </Text>
    <Text>Objeto, equipamentos, ou processo que é designado como a origem dos riscos ocupacionais</Text>
    <br />
    <Text bold size="small">
      EPI
    </Text>
    <Text>
      Equipamento de Proteção Individual (EPI) é todo dispositivo ou produto, de uso individual utilizado pelo
      trabalhador, destinado a proteção contra riscos capazes de ameaçar a sua segurança e a sua saúde.
    </Text>
    <br />
    <Text bold size="small">
      EPC
    </Text>
    <Text>
      Equipamentos de proteção coletiva - EPC são dispositivos utilizados no{' '}
      <a href="http://www.guiatrabalhista.com.br/tematicas/leiantifumo_trabalho.htm">ambiente de trabalho</a> com o
      objetivo de proteger os trabalhadores dos riscos inerentes aos processos, tais como o enclausuramento acústico de
      fontes de ruído, ventilação dos locais de trabalho, proteção de partes móveis de máquinas e equipamentos,
      sinalização de segurança, entre outros.
    </Text>
    <br />
    <Text bold size="small">
      MEDIDAS EXISTENTES
    </Text>
    <Text>
      Medidas de Controle do Risco ou Ações de controle coletivas, individuais ou administrativas, presentes no ambiente
      de trabalho que mitigam ou eliminam a exposição aos riscos.
    </Text>
    <br />
    <Text bold size="small">
      MEDIDAS PROPOSTAS
    </Text>
    <Text>
      Medidas de Controle do Risco ou Ações de controle coletivas, individuais ou administrativas, propostas
      tecnicamente para o ambiente de trabalho para que haja a mitigação ou eliminação da exposição aos riscos.
    </Text>
    <br />
    <Text bold size="small">
      AVALIAÇÃO OU ANÁLISE QUALITATIVA
    </Text>
    <Text>
      São realizadas entrevistas com os funcionários para identificação dos escopos do trabalho assim como a interação
      homem-máquina. São verificadas as atividades, máquinas e equipamentos onde ocorra o contato com substâncias ou
      agentes agressivos ao trabalhador.
      <br />
      Quando identificada exposição ocupacional, são verificados os métodos de trabalho, equipamentos de proteção
      individuais utilizados e medidas coletivas de proteção. O ambiente de trabalho onde são executadas as atividades é
      avaliado levando em consideração aspectos relevantes a proteção e bem-estar do colaborador. Esses dados são usados
      para alimentara a Análise de Riscos e a definição do Nível de Risco do Trabalhador.
    </Text>
    <br />
    <Text bold size="small">
      AVALIAÇÃO QUANTITATIVA
    </Text>
    <Text>
      Avaliação através de equipamentos de medição ou de quantificação que determinam valores de exposição. Podem ser
      métodos dosimétricos, quantificação de agentes químicos no ambientem entre outros, de acordo com metodologia
      específica.
    </Text>
    <br />
    <Text bold size="small">
      FUNDAMENTAÇÃO LEGAL
    </Text>
    <Text>
      Fontes de referências legais que subsidiam a definição de limites de tolerância ou aspectos qualitativos de
      análise.
    </Text>
    <br />
    <Text bold size="small">
      METODOLOGIA
    </Text>
    <Text>Método aplicado para determinação de uma análise, avaliação, quantificação ou medição.</Text>
    <br />
    <Text bold size="small">
      GRUPOS HOMOGÊNEOS DE EXPOSIÇÃO (GHE)
    </Text>
    <Text>
      Para elaboração deste documento adotou-se a definição de Grupo Homogêneo de Exposição (GHE), que corresponde a um
      grupo de trabalhadores que experimentam exposição semelhante de forma que, o resultado fornecido pela avaliação da
      exposição de qualquer trabalhador do grupo seja representativo da exposição do restante dos trabalhadores do mesmo
      grupo.
      <br />
      Um grupo é homogêneo no sentido estatístico, e isso permite que um número relativamente pequeno de amostras possa
      definir as tendências de exposição de todo o grupo.
      <br />
      Depois de observar e conhecer as exposições, reunir os trabalhadores em grupos que possuem as mesmas chances de
      exposição a um dado agente. Essa “igualdade” provém do desenvolvimento de rotinas e tarefas essencialmente
      idênticas ou similares do ponto de vista da exposição.
    </Text>
    <br />
    <Text bold size="small">
      RISCO
    </Text>
    <Text>
      Combinação da probabilidade de ocorrência de um evento perigoso ou exposição com a gravidade da lesão ou doença
      que pode ser causada pelo evento ou exposição.
    </Text>
    <br />
    <Text bold size="small">
      PERIGO
    </Text>
    <Text>
      É uma condição ou um conjunto de circunstâncias que têm o potencial de causar ou contribuir para uma lesão ou
      morte.
    </Text>
    <br />
    <Text bold size="small">
      IDENTIFICAÇÃO DE PERIGO
    </Text>
    <Text>Processo de reconhecimento que um perigo existe, e de definição de suas características.</Text>
    <br />
    <Text bold size="small">
      AVALIAÇÃO DE RISCOS
    </Text>
    <Text>
      Processo de avaliação de risco proveniente de perigo, levando em consideração a adequação de qualquer controle
      existente, e decidindo se o risco é ou não aceitável.
    </Text>
    <br />
    <Text bold size="small">
      RISCOS OCUPACIONAIS
    </Text>
    <Text>
      São considerados riscos ocupacionais os agentes físicos, químicos, biológicos, Mecânicos (acidentes) e ergonômicos
      que, em função de sua natureza, concentração ou intensidade e tempo de exposição, forem capazes de causar danos à
      saúde do trabalhador.
    </Text>
    <br />
    <Text bold size="small">
      AGENTES FÍSICOS
    </Text>
    <Text>
      São as diversas formas de energia a que possam estar expostos os trabalhadores. Devem ser considerados durante as
      avaliações, os agentes físicos que se apresentam nas seguintes formas de energia: ruído; vibração; pressões
      anormais; temperaturas extremas; radiações ionizantes; radiação não ionizantes; infrassom e ultrassom.
    </Text>
    <br />
    <Text bold size="small">
      AGENTES QUÍMICOS
    </Text>
    <Text>
      São as substâncias, compostos ou produtos que possam penetrar no organismo pela via respiratória, nas formas de
      poeiras, fumos, névoas, neblinas, gases ou vapores, ou que, pela natureza da atividade de exposição, possam ter
      contato ou ser absorvido pelo organismo através da pele ou por ingestão.
      <br />
      Para fins de desenvolvimento do PGR, a avaliação deverá contemplar todas aquelas substâncias existentes no
      processo produtivo, sendo que as avaliações quantitativas da exposição dos trabalhadores deverão considerar os
      valores dos limites previstos na NR-15 enquanto não forem estabelecidos os anexos da NR-9 ou, na ausência destes
      os valores limites de exposição ocupacional adotados pela{' '}
      <i>American Conference of Governmental Industrial Higyenists</i> - ACGIH, ou aqueles que venham a ser
      estabelecidos em negociação coletiva de trabalho, desde que mais rigorosos do que os critérios técnico-legais
      estabelecidos.
    </Text>
    <br />
    <Text bold size="small">
      AGENTES BIOLÓGICOS
    </Text>
    <Text>
      São os microorganismos e parasitas ou materiais originados de organismos que, em função de sua natureza e do tipo
      de exposição, são capazes de acarretar lesão ou agravo à saúde do trabalhador. Exemplos: bactéria Bacillus
      anthracis, vírus linfotrópico da célula T humana, príon agente de doença de Creutzfeldt-Jakob, fungo Coccidioides
      immitis.
      <br />
      No desenvolvimento do PGR, serão consideradas como parâmetro na avaliação qualitativa as atividades relacionadas
      no Anexo 14 da NR-15.
    </Text>
    <br />
    <Text bold size="small">
      AGENTES MECÂNICOS (Ou Acidentes)
    </Text>
    <Text>
      São os potencialmente geradores de acidentes, como o arranjo físico deficiente; máquinas e equipamentos sem
      proteção; ferramentas inadequadas; ou defeituosas; eletricidade; incêndio ou explosão; animais peçonhentos;
      armazenamento inadequado, dentre outros.
    </Text>
    <br />
    <Text bold size="small">
      AGENTES ERGONÔMICOS
    </Text>
    <Text>
      São todas as condições que afetam o bem-estar do indivíduo, sejam elas físicas, organizacional ou cognitiva. Podem
      ser compreendidas como fatores que interferem nas características psicofisiológicas do profissional, provocando
      desconfortos e problemas de saúde. São exemplos de riscos ergonômicos: levantamento de peso, ritmo excessivo de
      trabalho, monotonia, repetitividade, postura inadequada.{' '}
    </Text>
    <br />
    <Text bold size="small">
      AEP
    </Text>
    <Text>
      Análise Ergonômica Preliminar, prevista na Norma Regulamentadora 17, item 17.3.1.1:
      <br />
      <i>
        “A avaliação ergonômica preliminar das situações de trabalho pode ser realizada por meio de abordagens
        qualitativas, semiquantitativas, quantitativas ou combinação dessas, dependendo do risco e dos requisitos
        legais, a fim de identificar os perigos e produzir informações para o planejamento das medidas de prevenção
        necessárias”.
      </i>
    </Text>
    <br />
    <Text bold size="small">
      LIMITE DE TOLERÂNCIA / LIMITE DE EXPOSIÇÃO OCUPACIONAL
    </Text>
    <Text>
      Referem-se às concentrações ou intensidades que representam as condições sob as quais se acredita que quase todos
      os trabalhadores possam estar expostos continua e diariamente, sem apresentar efeitos adversos à saúde. Referem às
      concentrações médias máximas que não devem ser ultrapassadas numa jornada.
    </Text>
    <br />
    <Text bold size="small">
      NÍVEL DE AÇÃO
    </Text>
    <Text>
      É o valor, apurado na etapa de avaliação dos riscos, acima do qual deverão ser iniciadas as medidas preventivas de
      forma a minimizar a probabilidade de que as exposições a agentes ambientais ultrapassem os limites de exposição
      tais como:
      <ul>
        <li>Medições periódicas da exposição ocupacional;</li>
        <li>Treinamento dos trabalhadores;</li>
        <li>Acompanhamento médico com monitoramentos biológicos apropriados.</li>
      </ul>
      Os níveis de ação adotados são aqueles previstos na NR-9:
      <ul>
        <li>Agentes Químicos: Metade dos limites de exposição ocupacionais adotados.</li>
        <li>Ruído: Dose de 0,5 (50% de dose) do limite de tolerância previsto para a jornada de trabalho.</li>
      </ul>
    </Text>
    <br />
    <Text bold size="small">
      VALOR TETO
    </Text>
    <Text>Concentração que não pode ser excedida durante nenhum momento da exposição do trabalhador.</Text>
    <br />
    <Text bold size="small">
      MEIO DE PROPAGAÇÃO
    </Text>
    <Text>Material, ambiente ou canal físico que o agente se propaga no ambiente de trabalho.</Text>
    <br />
    <Text bold size="small">
      TEMPO DE EXPOSIÇÃO
    </Text>
    <Text>O tempo estimado diário durante o qual o trabalhador permanece exposto a um risco</Text>
    <br />
    <Text bold size="small">
      CONCENTRAÇÃO / INTENSIDADE
    </Text>
    <Text>Avaliação qualitativa ou quantitativa da presença de determinado agente.</Text>
    <br />
    <Text bold size="small">
      PROBABLILIDADE
    </Text>
    <Text>Resultado matricial da combinação entre Tempo de Exposição vezes Concentração/Intensidade de um agente.</Text>
    <br />
    <Text bold size="small">
      POTENCIAL DE DANO (Severidade)
    </Text>
    <Text>
      É a consequência de uma situação de perigo à segurança operacional em termos de lesão, doença, ou uma combinação
      desses, além de limites de tolerância e características químicas.
    </Text>
    <br />
    <Text bold size="small">
      TEMPO DE EXPOSIÇÃO
    </Text>
    <Text>O tempo estimado diário durante o qual o trabalhador permanece exposto a um risco.</Text>
    <br />
    <Text bold size="small">
      GRADUAÇÃO DO RISCO
    </Text>
    <Text>
      Combinação da severidade com a probabilidade do efeito potencial de um perigo ocorrer, no pior cenário verossímil
      possível.
    </Text>
    <br />
    <Text bold size="small">
      GRAU DE INCERTEZA
    </Text>
    <Text>
      Estimativa baseada em dados quantitativos confiáveis para agentes cujos efeitos à saúde são bem conhecidos ou
      dados qualitativos objetivos.
    </Text>
    <br />
    <Text bold size="small">
      LAUDO DE PERICULOSIDADE (LTP) - NR N° 16 - ATIVIDADES E OPERAÇÕES PERIGOSAS, APROVADA PELA PORTARIA MTB N°. 3.214
      DE 08 DE JUNHO DE 1978.
    </Text>
    <Text>
      Avaliar e identificar a existência de atividades periculosas face aos diplomas legais estabelecidos pela Lei nº
      6.514, de 22/12/88, que altera o Capítulo V do Título II da CLT, relativo a Segurança e Medicina do Trabalho,
      Portaria nº 3.214/78, de 08/06/78, que aprova as normas regulamentadoras NR´s.{' '}
    </Text>
    <br />
    <Separator weight={4} />
  </View>
)

export default CoverSection
